import { requestJson } from "../api/apiClient";

const PUBLIC_BASE = "/api/v1/automap";
const ADMIN_BASE = "/api/admin/automotive/fair-price";
const DEALER_BASE = "/api/v1/automap/dealer-portal";

export function fetchListingFairPrice(listingId) {
  return requestJson(`${PUBLIC_BASE}/listings/${encodeURIComponent(listingId)}/fair-price`).then(
    (data) => data.snapshot
  );
}

export function fetchAdminListingFairPrice(listingId) {
  return requestJson(`${ADMIN_BASE}/listings/${encodeURIComponent(listingId)}`).then((data) => ({
    snapshot: data.snapshot,
    comparables: data.comparables || [],
  }));
}

export function recalculateAdminListingFairPrice(listingId) {
  return requestJson(`${ADMIN_BASE}/listings/${encodeURIComponent(listingId)}/recalculate`, {
    method: "POST",
    body: JSON.stringify({}),
  }).then((data) => data.snapshot);
}

export function fetchDealerFairPriceInsights(dealerId) {
  return requestJson(`${DEALER_BASE}/dealers/${encodeURIComponent(dealerId)}/fair-price-insights`);
}
